import { getTrackOrderStatusByTrackings } from '@/components/content/OrderHistoryDetails/parts/TrackOrder';
import { getTrackOrderTextByStatus } from '@/components/content/OrderHistoryDetails/parts/TrackOrderSteps';
import { ORDER_STATUS_COLORS, ORDER_STATUS_DESCRIPTION } from '@/data/types/Order';

interface Tracking {
	stage: string;
	end: string | null;
	start: string;
}

export const RenderOrderStatus = ({
	trackings,
	orderStatus: _orderStatus,
	render,
}: {
	trackings: Tracking[];
	orderStatus?: string;
	render: (status: string, color: string) => React.ReactElement;
}) => {
	if (trackings.length > 0) {
		const orderStatusKey = getTrackOrderStatusByTrackings(trackings);
		return render(getTrackOrderTextByStatus(orderStatusKey), ORDER_STATUS_COLORS[orderStatusKey]);
	}

	const orderStatusKey = _orderStatus
		? (_orderStatus as keyof typeof ORDER_STATUS_DESCRIPTION)
		: 'W';

	return render(ORDER_STATUS_DESCRIPTION[orderStatusKey], ORDER_STATUS_COLORS[orderStatusKey]);
};
